export const retentionTags = {
	popup: 'popup',
};
